import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, LoaderCircle } from "lucide-react";
import { toast } from "sonner";
import { MediaPreviewDialog } from "@/components/admin/MediaPreviewDialog";
import { MediaThumbs } from "@/components/admin/MediaThumbs";
import { ComplaintSummary } from "@/components/progress/ComplaintSummary";
import { ProgressTimeline } from "@/components/progress/ProgressTimeline";
import { ReplyBox } from "@/components/progress/ReplyBox";
import { api, formatApiError } from "@/lib/api";

export default function MyComplaintDetailPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [preview, setPreview] = useState({ items: [], index: null });

  useEffect(() => {
    api.get(`/my/complaints/${id}`)
      .then((res) => setData(res.data))
      .catch((err) => setError(formatApiError(err, "Pengaduan tidak ditemukan")));
  }, [id]);

  const sendReply = async (message) => {
    try {
      const { data: update } = await api.post(`/my/complaints/${id}/replies`, { message });
      setData((d) => ({ ...d, updates: [...d.updates, update] }));
      toast.success("Balasan terkirim ke pengurus RT");
    } catch (err) {
      toast.error(formatApiError(err, "Gagal mengirim balasan"));
      throw err;
    }
  };

  return (
    <main className="mx-auto max-w-4xl space-y-6 px-4 py-8 sm:px-6" data-testid="my-complaint-detail-page">
      <Link to="/pengaduan-saya" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-emerald-700" data-testid="back-to-list-link">
        <ArrowLeft className="h-4 w-4" /> Kembali ke Pengaduan Saya
      </Link>
      {error && <p className="rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-700" data-testid="my-detail-error">{error}</p>}
      {!data && !error && (
        <div className="flex items-center justify-center gap-2 py-16 text-sm text-slate-500"><LoaderCircle className="h-5 w-5 animate-spin text-emerald-600" /> Memuat detail...</div>
      )}
      {data && (
        <>
          <ComplaintSummary complaint={data.complaint} attachmentsCount={data.complaint.attachments.length}>
            {data.complaint.attachments.length > 0 && (
              <MediaThumbs attachments={data.complaint.attachments} onOpen={(items, index) => setPreview({ items, index })} ownerId="my" />
            )}
          </ComplaintSummary>
          <section className="space-y-4">
            <h3 className="font-heading text-lg font-bold text-slate-900">Progres & Tanggapan</h3>
            <ProgressTimeline updates={data.updates} />
            {data.updates.some((u) => u.author_role === "admin") ? (
              <ReplyBox onSend={sendReply} />
            ) : (
              <p className="rounded-xl bg-slate-50 p-4 text-sm text-slate-500" data-testid="reply-waiting-note">
                Anda dapat membalas setelah Pengurus RT memberikan tanggapan pertama.
              </p>
            )}
          </section>
        </>
      )}
      <MediaPreviewDialog
        items={preview.items}
        index={preview.index}
        onIndexChange={(index) => setPreview((p) => ({ ...p, index }))}
        onClose={() => setPreview({ items: [], index: null })}
      />
    </main>
  );
}
